<template>
  <div
    ref="wrapper"
    class="swiper-titles"
  >
    <f7-swiper
      v-if="swiper.length"
      ref="markers"
      :params="{
        slidesPerView: 1,
        speed: 500,
        centeredSlides: true,
        on: { slideChange }
      }"
    >
      <f7-swiper-slide
        v-for="m in swiper"
        :key="m._id"
      >
        <PlayerProgress
          v-if="markerSpeech && markerSpeech._id === m._id"
          :title="m.title"
          :subtitle="playlistSubtitle"
          :progress="playlistProgress"
        />
        <h2
          v-else
          class="swiper-title"
          @click="read(m)"
        >
          {{ m.title }}
        </h2>
      </f7-swiper-slide>
    </f7-swiper>
  </div>
</template>

<script>
import PlayerProgress from '@/components/ui/Player/PlayerProgress'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'SwiperTitles',
  components: {
    PlayerProgress
  },
  computed: {
    ...mapGetters({
      swiper: 'global/swiper',
      highlight: 'global/highlight',
      markerSpeech: 'speech/markerSpeech',
      playlistSubtitle: 'speech/playlistSubtitle',
      playlistProgress: 'speech/playlistProgress'
    })
  },
  watch: {
    highlight (marker) {
      if (marker && this.$refs && this.$refs.markers) {
        this.slideTo(marker._id)
      }
    }
  },
  methods: {
    ...mapActions({
      setHighlight: 'global/setHighlight'
    }),
    slideChange (e) {
      const i = this.$refs.markers.swiper.activeIndex
      if (this.swiper[i]._id !== this.highlight._id) {
        this.setHighlight(this.swiper[i])
      }
    },
    slideTo (id) {
      const marker = this.swiper.find(m => m._id === id)
      if (marker) {
        const i = this.swiper.indexOf(marker)
        this.$refs.markers.swiper.slideTo(i)
      }
    },
    read (m) {
      this.$f7router.navigate('/article/' + m._id)
    }
  },
  mounted () {
    if (this.highlight) this.slideTo(this.highlight._id)
  }
}
</script>

<style lang="scss">
.swiper-titles {
  display: block;
  position: relative;
}
.swiper-title {
  display: block;
  position: relative;
  margin: 0 16px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "Aleo";
  font-weight: bold;
  font-size: 16px;
  line-height: 60px;
  padding: 0 40px;
  color: var(--f7-navbar-large-title-text-color);
}
</style>
